import * as React from 'react'

function SvgFaq(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 10a4 4 0 018 0c0 1.133-.273 1.797-.592 2.267-.357.526-.861.948-1.608 1.508l-.21.156c-.653.485-1.532 1.138-2.214 1.992C13.536 16.973 13 18.287 13 20a2 2 0 104 0c0-.787.215-1.223.5-1.579.343-.43.804-.775 1.55-1.334l.15-.112c.753-.565 1.75-1.33 2.517-2.46C22.523 13.327 23 11.866 23 10a8 8 0 10-16 0 2 2 0 104 0zm4 18a2 2 0 100-4 2 2 0 000 4z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgFaq
